var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(_vm.progress)?_c('v-progress-linear',{staticClass:"progress",attrs:{"indeterminate":"","color":"secondary"}}):_vm._e(),_c('v-container',{attrs:{"grid-list-sm":""}},[_c('v-row',{attrs:{"wrap":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }